/* @jsx h */
import { defineComponent, h } from "vue";
import { MembershipProgramsPage } from "../../../../ManagerPromotions/subpages/MembershipPrograms";
import { useGroupAuth } from "@app/vue/providers/GroupAuth";

export const GroupMembershipProgramsPage = defineComponent({
  name: "GroupMembershipProgramsPage",
  setup() {
    const auth = useGroupAuth();
    return () => (
      <MembershipProgramsPage
        scope="group"
        canManage={auth.isGroupAdmin.value}
      />
    );
  },
});
